import { apiClient } from '@/plugins/axios'; // Import your axios instance


const getSales = async (filters: Record<string, any> = {}) => {
  const params = new URLSearchParams(filters as any);
  return apiClient.get('/sales?' + params.toString()); // Let the error bubble up
};

const getSaleById = async (id: number) => {
  return await apiClient.get(`/sales/${id}`); // Fetch car listing by ID
};

const createSale = async (saleData: any) => {
  return await apiClient.post('/sales', saleData); // Create a new car listing
};

const updateSale = async (id: number, saleData: any) => {
  return await apiClient.patch(`/sales/${id}`, saleData); // Update car listing by ID
};

const deleteSale = async (id: number) => {
  return await apiClient.delete(`/sales/${id}`); // Delete car listing by ID
};

const getSoldByUser = async (filters: Record<string, any> = {}) => {
  const params = new URLSearchParams(filters as any);
  return apiClient.get('/dashboard/sold-by-user?' + params.toString()); // Let the error bubble up
};
const getSoldByMedium = async (filters: Record<string, any> = {}) => {
  const params = new URLSearchParams(filters as any);
  return apiClient.get('/dashboard/sold-by-medium?' + params.toString()); // Let the error bubble up
};
const getSoldByPoster = async (filters: Record<string, any> = {}) => {
  const params = new URLSearchParams(filters as any);
  return apiClient.get('/dashboard/sold-by-poster?' + params.toString()); // Let the error bubble up
};
const getSoldByProduct = async (filters: Record<string, any> = {}) => {
  const params = new URLSearchParams(filters as any);
  return apiClient.get('/dashboard/sold-by-product?' + params.toString()); // Let the error bubble up
};
const getSalesTotals = async (filters: Record<string, any> = {}) => {
  const params = new URLSearchParams(filters as any);
  return apiClient.get('/dashboard/sold-totals?' + params.toString()); // Let the error bubble up
};

const authorizeSaleItem = async (saleItemData: any) => {
  return await apiClient.post('/sale/authorize', {sale_item_ids:[saleItemData.id]});
};

const authorizeSale = async (saleData: any) => {
  return await apiClient.post('/sale/authorize', saleData); // Create a new car listing
};

const confirmSale = async (saleId: any) => {
  return await apiClient.post('/sales/confirm/' + saleId);
};

const exportCSV = async (params: string, body: any) => {
  return await apiClient.post(`/sales/export?${params}`, body, {
    responseType: 'blob',
    headers: {
      'Accept': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    }
  });
};

const exportInvoiceOrder = async (id:any) => {
  return await apiClient.get(`/sale/export-order/${id}`, {
    responseType: 'blob',
    headers: {
      'Accept': 'application/pdf'
    }
  });
};


export default {
  getSales,
  getSaleById,
  createSale,
  updateSale,
  deleteSale,
  getSoldByUser,
  getSoldByMedium,
  getSoldByPoster,
  getSoldByProduct,
  getSalesTotals,
  authorizeSaleItem,
  authorizeSale,
  exportCSV,
  confirmSale,
  exportInvoiceOrder
};
